<template>
  <div
    v-if="btn3dList && btn3dList.length > 0"
    class="other-news"
  >
    <div class="other-news__title h3 semibold">Другие 3Д проекты</div>

    <template v-if="$viewport.isGreaterOrEquals('lg')">
      <div class="other-news__list">
        <nuxt-link
          v-for="(article) in btn3dList"
          :key="`news-card-${ article.id }`"
          :to="`/3d-projects/${article.slug}`"
          class="news-card"
        >
          <div class="news-card__image">
            <nuxt-img
              :src="String(article.image_id)"
              :width="120"
              :height="120"
              :placeholder="true"
              fit="cover"
              :alt="`${article.title}-image-${article.image_id}`"
            />
          </div>
          <div class="news-card__content">
            <div class="news-card__title h5">
              {{ article.title }}
            </div>
            <div class="news-card__link">
              <div class="h6">Читать статью</div>
            </div>
          </div>
        </nuxt-link>
      </div>
    </template>
    <template v-if="!$viewport.isGreaterOrEquals('lg')">
      <div class="other-news__slider">
        <swiper
          virtual
          class="other-news-swiper"
          :modules="[Pagination, Virtual]"
          :pagination="{
            el:'.swiper-pagination-mobile',
            enabled: true,
            type: 'bullets'
          }"

          :init="true"
          :space-between="16"
          :slides-per-view="1"
          :breakpoints="{
            640: {
              slidesPerView: 2
            }
          }"
        >
          <swiper-slide
            v-for="(article) in btn3dList"
            :key="`news-card-${ article.id }`"
            class="swiper-slide"
          >
            <nuxt-link
              :to="`/3d-projects/${article.slug}`"
              class="news-card"
            >
              <div class="news-card__image">
                <nuxt-img
                  :src="String(article.image_id)"
                  :width="120"
                  :height="120"
                  :placeholder="true"
                  fit="cover"
                  :alt="`${article.title}-image-${article.image_id}`"
                />
              </div>
              <div class="news-card__content">
                <div class="news-card__title h5">
                  {{ article.title }}
                </div>
                <div class="news-card__link">
                  <div class="btn btn-primary">Подробнее</div>
                </div>
              </div>
            </nuxt-link>
          </swiper-slide>
          <div class="swiper-pagination-mobile"></div>
        </swiper>
      </div>
    </template>
  </div>
</template>

<script setup lang="ts">
import type { Project3dListType } from '~/components/collection/3d-project/Project3d.vue';
import { useRoute } from '#imports';
import {Swiper, SwiperSlide} from 'swiper/vue';
import type {Swiper as SwiperClass} from 'swiper/types';
import { Pagination, Virtual } from 'swiper/modules';
import CollectionCard from '~/components/catalog/CollectionCard.vue';
import ProductCard from '~/components/catalog/ProductCard.vue';

const $route = useRoute();
const {
  $api
} = useNuxtApp();
const props = defineProps<{
	projectId: number;
}>();
const btn3dList = ref<Project3dListType[]>([]);
const {
  data,
  execute
} = await useLazyAsyncData<Project3dListType[]>(`${$route.path}-3d-project`, async () => await $api.agent
  .get('projects?per-page=4')
  .then((res) => res._data), { immediate: false, server: false });

onMounted(async () => {
  await execute();

  if (data.value) {
    btn3dList.value = data.value;

    btn3dList.value = btn3dList.value.filter((t) => t.id !== props.projectId);
  }
});
</script>

<style scoped lang="scss">
.other-news {
}

.other-news__title {
	margin-bottom: 24px;
}

.other-news__list {
	display: flex;
	flex-direction: column;

	& > * {
		margin-top: 24px;
	}
}

.news-card {
	display: flex;
	align-items: center;
	cursor: pointer;

	&:hover {
		.news-card__link div {
			text-decoration-color: transparent;
		}
	}
}

.news-card__image {
	width: 100%;
	max-width: 120px;
	border-radius: 6px;
	position: relative;
	background-color: #EEEDED;
	margin-right: 24px;
	overflow: hidden;

	img {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		object-fit: cover;
	}

	&:after {
		content: "";
		float: left;
		padding-top: 100%;
	}
}

.news-card__content {
	flex: 1;
}

.news-card__title {
	color: black;
}

.news-card__link {
	margin-top: 16px;

	div {
		color: #989898;
		text-decoration: underline;
	}
}

@media (max-width: 1023px) {
  .other-news {
    padding: 80px var(--container-padding);
    padding-bottom: 0;
    box-sizing: border-box;
    position: relative;
    background: white;
    z-index: 5;
    margin-top: 63px;
  }
	.other-news__title {
		margin-bottom: 0;
		font-size: 28px;
    line-height: 35px;
	}

  .news-card {
    flex-direction: column;
    border: 1px solid #EBEBEB;
    border-radius: 16px;
    position: relative;
    overflow: hidden;
  }
  .news-card__image {
    max-width: initial;
    margin-right: 0;
    &:after {
      padding-top: 62.5%;
    }
  }
  .news-card__content {
    padding: 24px;
    box-sizing: border-box;
  }
  .news-card__title {
    font-size: 16px;
    line-height: 22px;
  }
  .news-card__link {
    margin-top: 24px;
    div {
      text-decoration: initial;
      color: white;
      border-radius: 12px;
    }
  }
}
</style>
<style lang="scss">
.other-news__slider {
  margin-top: 32px;
  .swiper {
    margin: 0 calc(var(--container-padding) * -1);
    padding: 0 var(--container-padding);
  }
  .swiper-pagination-mobile {
    position: relative;
    margin-top: 34px;
    display: flex;
    justify-content: center;

    & > * {
      opacity: 1;
      width: 10px !important;
      height: 10px !important;
      background-color: #EBEBEB;

      &.swiper-pagination-bullet-active {
        background-color: black!important;
      }
    }
  }
}
</style>
